<div class="progress-indicator-container">
    <app-loading-indicator></app-loading-indicator>
</div>